module.exports = __webpack_public_path__ + "img/3.4efa29b5.jpg";